import script from "./FullScreenImage.vue?vue&type=script&lang=ts&setup=true"
export * from "./FullScreenImage.vue?vue&type=script&lang=ts&setup=true"

import "./FullScreenImage.vue?vue&type=style&index=0&id=b396bf8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b396bf8e"]])

export default __exports__